'use strict';

angular.module('app.networkInfluencerList')

.directive('networkInfluencerListDirective', function () {
        return {
            controller: 'networkInfluencerListCtrl',
            templateUrl: 'app/sideBarMenu/networkInfluencerList/networkInfluencerList.html?app_v=deployDate',
            scope: {}
        };
})